import { render, staticRenderFns } from "./order_stay_detail.vue?vue&type=template&id=42630c26&scoped=true"
import script from "./order_stay_detail.vue?vue&type=script&lang=js"
export * from "./order_stay_detail.vue?vue&type=script&lang=js"
import style0 from "./order_stay_detail.vue?vue&type=style&index=0&id=42630c26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42630c26",
  null
  
)

export default component.exports